import Image from 'next/image';
import styles from './styles.module.scss';

const TestimonialSingle = props => {
    const {title, name, image, copy, slide} = props || {};

    const renderImage = () => {
        const {mediaItemUrl, mediaDetails, altText} = image?.node || {};
        if(!mediaItemUrl) return null;
        return(
            <Image alt={altText || 'title'} width={mediaDetails?.width} height={mediaDetails?.height} src={mediaItemUrl} className={styles.testimonial__headshot}/>
        );
    }

    const renderQuote = () => {
        if(!copy) return null;
        return(
            <h4 className={styles.testimonial__quote}>
                {copy}
            </h4>
        );
    }

    return(
            <div>
                {renderQuote()}
                <div  className={styles.testimonial__meta}>
                    {renderImage()}
                    <div  className={styles.testimonial__attribution}>
                        <h4  className={styles.testimonial__name}>
                            {name}
                        </h4>
                        <p className={styles.testimonial__title}>
                            {title}
                        </p>
                    </div>
                </div>
            </div>
    );
}

export default TestimonialSingle;